import { Sparkles } from "lucide-react";

export function FeaturedBadge({ className = "", testid = "featured-badge", onDark = false }) {
  return (
    <span data-testid={testid}
          className={`inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full border ${onDark ? "bg-white/90 text-zinc-800 border-white/60" : "bg-zinc-100 text-zinc-700 border-zinc-200"} ${className}`}>
      <Sparkles size={10} /> Destaque
    </span>
  );
}
